import { SavedAudienceStatus } from '@marketing-milk/interfaces'

/** Chip styling per audience status. Same shape and tones as the campaigns chip,
 *  so one screen showing both doesn't read as two different systems. */
export const audienceStatusStyles: Record<
  SavedAudienceStatus,
  { text: string; toneClass: string }
> = {
  [SavedAudienceStatus.Processing]: {
    text: 'Populating',
    toneClass: 'bg-mm-turquoise-100 text-mm-turquoise-800',
  },
  [SavedAudienceStatus.Active]: {
    text: 'Active',
    toneClass: 'bg-mm-success-100 text-mm-success-800',
  },
  // Facebook also sends PENDING, which the interfaces enum doesn't carry.
  // @ts-ignore - the interfaces lib is out of whack at the moment
  PENDING: {
    text: 'Pending',
    toneClass: 'bg-mm-turquoise-100 text-mm-turquoise-800',
  },
}

export interface AudienceStatusIndicatorProps {
  status: SavedAudienceStatus
  className?: string
}
